import { Project, Supplier, useApp } from "~/core";

type Api = ReturnType<typeof useApp>["api"];

const safe = <T>(promise: Promise<T>) => promise.catch(() => null);

const joinNonEmpty = (...parts: (string | undefined)[]) =>
    parts.filter(Boolean).join(" ");

export const getPurchaseOrderAutofill = async (
    api: Api,
    project: Project,
    supplier: Supplier,
) => {
    const [projectInfo, supplierInfo] = await Promise.all([
        safe(api.project.info(project)),
        safe(api.supplier.info(supplier)),
    ]);
    const address = supplierInfo?.address;

    return {
        client_name: projectInfo?.addr_client || project.client,
        delivery_address1: projectInfo?.addr_street ?? "",
        delivery_address2: projectInfo?.addr_department ?? "",
        delivery_address3: projectInfo?.addr_zip_city ?? "",
        delivery_address4: projectInfo?.addr_country ?? "",
        supplier: {
            ...address,
            name: address?.name || supplier.name,
            zip_city:
                address?.zip_city ||
                joinNonEmpty(supplierInfo?.zip_code, supplierInfo?.city),
        },
    };
};

export const getInvoiceAutofill = async (api: Api, project: Project) => {
    const projectInfo = await safe(api.project.info(project));

    return {
        contact_person: projectInfo?.contact_name || undefined,
    };
};
